// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Navbar_optionsNavbar__Qpecr {
  color: white;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

.Navbar_btnLogin__jKirJ {
  color: white;
  text-decoration: none;
  border: 1px solid rgba(255, 255, 255, 0.8);
  padding: 8px 18px;
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
  transition: background-color 0.2s;
}

.Navbar_btnLogin__jKirJ:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.Navbar_btnRegister__C1QPi {
  color: white;
  text-decoration: none;
  background-color: #2db899;
  padding: 8px 18px;
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
  transition: background-color 0.2s;
}

.Navbar_btnRegister__C1QPi:hover {
  background-color: #25a085;
}

.Navbar_logo__8S3W3 {
  width: 170px;
  display: block;
}

.Navbar_logoMobile__CwNTN {
  width: 170px;
  background-color: #1a3a5c;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Navbar/Navbar.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B","sourcesContent":[".optionsNavbar {\n  color: white;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.btnLogin {\n  color: white;\n  text-decoration: none;\n  border: 1px solid rgba(255, 255, 255, 0.8);\n  padding: 8px 18px;\n  border-radius: 4px;\n  font-size: 14px;\n  white-space: nowrap;\n  transition: background-color 0.2s;\n}\n\n.btnLogin:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.btnRegister {\n  color: white;\n  text-decoration: none;\n  background-color: #2db899;\n  padding: 8px 18px;\n  border-radius: 4px;\n  font-size: 14px;\n  white-space: nowrap;\n  transition: background-color 0.2s;\n}\n\n.btnRegister:hover {\n  background-color: #25a085;\n}\n\n.logo {\n  width: 170px;\n  display: block;\n}\n\n.logoMobile {\n  width: 170px;\n  background-color: #1a3a5c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"optionsNavbar": `Navbar_optionsNavbar__Qpecr`,
	"btnLogin": `Navbar_btnLogin__jKirJ`,
	"btnRegister": `Navbar_btnRegister__C1QPi`,
	"logo": `Navbar_logo__8S3W3`,
	"logoMobile": `Navbar_logoMobile__CwNTN`
};
export default ___CSS_LOADER_EXPORT___;
